<template>
  <section class="offerings-overview position-relative see__pad">
    <!-- Multiple Pattern Layers like React.js -->
    <div class="pattern-layer">
      <div class="pattern-1 position-absolute" style="background-image: url('/shapes/shape-03.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-2 position-absolute" style="background-image: url('/shapes/shape-05.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-3 position-absolute" style="background-image: url('/shapes/shape-07.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-4 position-absolute" style="background-image: url('/shapes/shape-09.png')"></div>
    </div>
    
    <div class="container d-block">
      <div class="row">
        <div class="col-lg-12">
          <div class="offerings-header text-center">
            <div class="offerings-section-label">
              <h4>{{ content.sectionLabel }}</h4>
            </div>
            <div class="offerings-main-title">
              <h2>{{ content.mainTitle }} <span>{{ content.mainTitleHighlight }}</span></h2>
            </div>
            <div class="offerings-description">
              <p>{{ content.description }}</p>
            </div>
          </div>
        </div>
      </div>
      
      <div class="row">
        <div class="col-lg-12">
          <div class="offerings-blocks-container">
            <div 
              v-for="(block, index) in content.blocks" 
              :key="index"
              class="offerings-block position-relative"
              :class="`${block.blockClass}`"
            >
              <div class="offerings-block-bg">
                <div class="block-shape-1" :style="`background-image: url('${block.shape1}')`"></div>
                <div class="block-shape-2" :style="`background-image: url('${block.shape2}')`"></div>
              </div>
              <div class="offerings-block-content">
                <div class="offerings-block-icon">
                  <i :class="block.icon"></i>
                </div>
                <h3>{{ block.title }}</h3>
                <p>{{ block.description }}</p>
                <ul>
                  <li v-for="(item, itemIndex) in block.features" :key="itemIndex">{{ item }}</li>
                </ul>
                <div class="offerings-block-cta">
                  <router-link :to="block.ctaLink" class="offerings-btn">
                    <i class="icon-02"></i> {{ block.ctaText }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HomeItsOurOfferingsComp",
  props: {
    content: {
      type: Object,
      required: true,
      default: () => ({
        sectionLabel: "What We Do",
        mainTitle: "From Idea to Product –",
        mainTitleHighlight: "We Build It All",
        description: "We develop world-class software products powered by the latest tech stacks — fast, scalable, and smart solutions for every industry.",
        blocks: [
          {
            blockClass: "services-block",
            icon: "icon-01",
            title: "Services",
            description: "Professional software development and technology services tailored to your business needs.",
            features: [
              "🔧 Software Product Development",
              "🧠 AI & Machine Learning Solutions",
              "📲 Mobile & Web App Development",
              "☁️ Cloud & DevOps Integration",
              "🛒 E-commerce & ERP Solutions",
              "🔐 Cybersecurity Tools"
            ],
            ctaText: "Explore Services",
            ctaLink: "/services/normal-car",
            shape1: "/shapes/shape-01.png",
            shape2: "/shapes/shape-11.png"
          },
          {
            blockClass: "synergy-block",
            icon: "icon-03",
            title: "Synergy Products",
            description: "Innovative products and solutions that combine cutting-edge technology with practical applications.",
            features: [
              "AR/VR Solutions",
              "AI-Powered Tools",
              "Mobile Applications",
              "Enterprise Software"
            ],
            ctaText: "View Products",
            ctaLink: "/products",
            shape1: "/shapes/shape-02.png",
            shape2: "/shapes/shape-12.png"
          },
          {
            blockClass: "research-block",
            icon: "icon-04",
            title: "Research",
            description: "Pioneering research initiatives that push the boundaries of technology and innovation.",
            features: [
              "Emerging Technologies",
              "Industry Analysis",
              "Innovation Labs",
              "Academic Partnerships"
            ],
            ctaText: "Learn More",
            ctaLink: "/research",
            shape1: "/shapes/shape-04.png",
            shape2: "/shapes/shape-10.png"
          }
        ]
      })
    }
  }
}
</script>

<style scoped>
/* Our Offerings Overview Section Styles - React.js Style */
.offerings-overview {
  padding: 100px 0;
  background: #00061A;
  position: relative;
  overflow: hidden;
}

/* Multiple Pattern Layers like React.js */
.offerings-overview .pattern-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.offerings-overview .pattern-1 {
  top: 10%;
  right: 5%;
  width: 200px;
  height: 200px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.offerings-overview .pattern-2 {
  top: 20%;
  left: 5%;
  width: 150px;
  height: 150px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

.offerings-overview .pattern-3 {
  bottom: 20%;
  right: 10%;
  width: 180px;
  height: 180px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.12;
}

.offerings-overview .pattern-4 {
  bottom: 10%;
  left: 10%;
  width: 120px;
  height: 120px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.offerings-overview .offerings-header {
  position: relative;
  z-index: 2;
  margin-bottom: 60px;
}

.offerings-overview .offerings-section-label h4 {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 13.2px;
  color: #F6EC4F;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
  text-transform: uppercase;
}

.offerings-overview .offerings-main-title h2 {
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
  color: #fff;
  margin-bottom: 30px;
  font-family: 'Archivo', sans-serif;
}

.offerings-overview .offerings-main-title h2 span {
  color: #F6EC4F;
}

.offerings-overview .offerings-description p {
  font-size: 18px;
  line-height: 28px;
  color: #fff;
  margin-bottom: 0;
  font-family: 'Open Sans', sans-serif;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

/* Block Styles like React.js Choose section - Compact Cards */
.offerings-overview .offerings-blocks-container {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;
  margin-top: 50px;
  margin-bottom: 40px;
}

.offerings-overview .offerings-block {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(246, 236, 79, 0.1);
  border-radius: 15px;
  padding: 30px 25px;
  text-align: left;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  height: auto;
  min-height: 280px;
}

.offerings-overview .offerings-block-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  pointer-events: none;
}

.offerings-overview .block-shape-1 {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 60px;
  height: 60px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.3;
}

.offerings-overview .block-shape-2 {
  position: absolute;
  bottom: 10px;
  left: 10px;
  width: 40px;
  height: 40px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.2;
}

.offerings-overview .offerings-block:hover {
  transform: translateY(-5px);
  border-color: #F6EC4F;
  box-shadow: 0 15px 30px rgba(246, 236, 79, 0.15);
}

.offerings-overview .offerings-block-content {
  position: relative;
  z-index: 2;
}

.offerings-overview .offerings-block-icon {
  margin-bottom: 20px;
  text-align: center;
}

.offerings-overview .offerings-block-icon i {
  font-size: 40px;
  color: #F6EC4F;
  display: inline-block;
  width: 60px;
  height: 60px;
  line-height: 60px;
  background: rgba(246, 236, 79, 0.1);
  border-radius: 50%;
  transition: all 0.3s ease;
}

.offerings-overview .offerings-block:hover .offerings-block-icon i {
  background: #F6EC4F;
  color: #00061A;
  transform: scale(1.1);
}

.offerings-overview .offerings-block-content h3 {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 15px;
  font-family: 'Archivo', sans-serif;
}

.offerings-overview .offerings-block-content p {
  font-size: 16px;
  line-height: 24px;
  color: #fff;
  margin-bottom: 20px;
  font-family: 'Open Sans', sans-serif;
}

.offerings-overview .offerings-block-content ul {
  list-style: none;
  padding: 0;
  margin: 0 0 20px 0;
}

.offerings-overview .offerings-block-content li {
  font-size: 14px;
  color: #F6EC4F;
  margin-bottom: 8px;
  font-family: 'Open Sans', sans-serif;
  position: relative;
  padding-left: 20px;
}

.offerings-overview .offerings-block-content li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #F6EC4F;
  font-weight: bold;
  font-size: 12px;
}

.offerings-overview .offerings-btn {
  display: inline-flex;
  align-items: center;
  padding: 12px 24px;
  background: #F6EC4F;
  color: #00061A;
  text-decoration: none;
  border-radius: 25px;
  font-family: 'Archivo', sans-serif;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
  position: relative;
  z-index: 2;
  border: 2px solid transparent;
  margin-top: 25px;
}

.offerings-overview .offerings-btn i {
  margin-right: 8px;
  font-size: 14px;
  transition: transform 0.3s ease;
}

.offerings-overview .offerings-btn:hover i {
  transform: translateX(-3px);
}

.offerings-overview .offerings-btn:hover {
  background: transparent;
  color: #F6EC4F;
  border-color: #F6EC4F;
  transform: translateX(5px);
}

/* Block-specific styles */
.offerings-overview .services-block {
  border-color: rgba(246, 236, 79, 0.2);
}

.offerings-overview .synergy-block {
  border-color: rgba(150, 6, 147, 0.2);
}

.offerings-overview .research-block {
  border-color: rgba(0, 123, 255, 0.2);
}

/* Responsive Design */
@media only screen and (max-width: 991px) {
  .offerings-overview {
    padding-bottom: 80px;
  }
}

@media only screen and (max-width: 767px) {
  .offerings-overview {
    padding-bottom: 60px;
  }
  
  .offerings-overview .offerings-main-title h2 {
    font-size: 36px;
    line-height: 46px;
  }
  
  .offerings-overview .offerings-description p {
    font-size: 16px;
  }
  
  .offerings-overview .offerings-blocks-container {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .offerings-overview .offerings-block {
    padding: 25px 20px;
    min-height: 250px;
  }
  
  .offerings-overview .offerings-block-content h3 {
    font-size: 20px;
  }
  
  .offerings-overview .offerings-block-content p {
    font-size: 14px;
    line-height: 22px;
  }
  
  .offerings-overview .pattern-1,
  .offerings-overview .pattern-2,
  .offerings-overview .pattern-3,
  .offerings-overview .pattern-4 {
    opacity: 0.05;
  }
}

@media only screen and (max-width: 399px) {
  .offerings-overview {
    padding-bottom: 40px;
  }
  
  .offerings-overview .offerings-main-title h2 {
    font-size: 28px;
    line-height: 38px;
  }
  
  .offerings-overview .offerings-section-label h4 {
    font-size: 16px;
    letter-spacing: 8px;
  }
  
  .offerings-overview .offerings-block {
    padding: 20px 15px;
    min-height: 220px;
  }
  
  .offerings-overview .offerings-block-content h3 {
    font-size: 18px;
  }
  
  .offerings-overview .offerings-block-content p {
    font-size: 13px;
    line-height: 20px;
  }
  
  .offerings-overview .offerings-block-icon i {
    width: 45px;
    height: 45px;
    line-height: 45px;
    font-size: 24px;
  }
  
  .offerings-overview .offerings-btn {
    padding: 8px 16px;
    font-size: 13px;
  }
  
  .offerings-overview .block-shape-1 {
    width: 30px;
    height: 30px;
  }
  
  .offerings-overview .block-shape-2 {
    width: 25px;
    height: 25px;
  }
}
</style>
